"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeExpressionLanguage = exports.language = exports.conf = void 0;
var javascript_1 = require("monaco-editor/esm/vs/basic-languages/javascript/javascript");
var Language_1 = require("../constants/Language");
exports.conf = javascript_1.conf;
exports.language = {
    defaultToken: 'invalid',
    ignoreCase: false,
    typeKeywords: javascript_1.language.typeKeywords,
    keywords: javascript_1.language.keywords,
    operators: javascript_1.language.operators,
    symbols: javascript_1.language.symbols,
    escapes: javascript_1.language.escapes,
    digits: javascript_1.language.digits,
    octaldigits: javascript_1.language.octaldigits,
    binarydigits: javascript_1.language.binarydigits,
    hexdigits: javascript_1.language.hexdigits,
    regexpctl: javascript_1.language.regexpctl,
    regexpesc: javascript_1.language.regexpesc,
    tokenizer: {
        root: javascript_1.language.tokenizer.root,
        common: javascript_1.language.tokenizer.common,
        whitespace: javascript_1.language.tokenizer.whitespace,
        comment: javascript_1.language.tokenizer.comment,
        jsdoc: javascript_1.language.tokenizer.jsdoc,
        regexp: javascript_1.language.tokenizer.regexp,
        regexrange: javascript_1.language.tokenizer.regexrange,
        string_double: javascript_1.language.tokenizer.string_double,
        string_single: javascript_1.language.tokenizer.string_single,
        string_backtick: javascript_1.language.tokenizer.string_backtick,
        bracketCounting: javascript_1.language.tokenizer.bracketCounting,
    },
};
var initializeExpressionLanguage = function (monaco) {
    if (!monaco)
        return;
    monaco.languages.setMonarchTokensProvider(Language_1.Language.JavaScript, exports.language);
    monaco.languages.setLanguageConfiguration(Language_1.Language.JavaScript, exports.conf);
    var compilerOptions = monaco.languages.typescript.javascriptDefaults.getCompilerOptions();
    monaco.languages.typescript.javascriptDefaults.setCompilerOptions(__assign(__assign({}, compilerOptions), { lib: [], allowNonTsExtensions: true }));
    var expressionTypesUrl = 'https://s3.us-west-2.amazonaws.com/assets.idearoom.com/types/expressionLib.d.ts';
    // Fetch the expression types file and add it as an extra library.
    // This allows the editor to use the types in the expression types file.
    fetch(expressionTypesUrl)
        .then(function (response) { return response.text(); })
        .then(function (libSource) {
        var libUri = 'ts:filename/expression.d.ts';
        monaco.languages.typescript.javascriptDefaults.addExtraLib(libSource, libUri);
        // When resolving definitions and references, the editor will try to use created models.
        // Creating a model for the library allows "peek definition/references" commands to work with the library.
        monaco.editor.createModel(libSource, 'typescript', monaco.Uri.parse(libUri));
    });
};
exports.initializeExpressionLanguage = initializeExpressionLanguage;
